import type { TursoWorkerDatabaseDriver } from '@w/db-turso-browser-adapter/worker'
import { ReplicaTransportError } from '@w/db-turso-browser-adapter/worker'

/** Explicit server reset fact carried by the existing generation_reset response. */
export function isDeletedWorkspaceReset(error: unknown): boolean {
  return error instanceof ReplicaTransportError && error.status === 410 && error.code === 'generation_reset' && error.deleted
}


/**
 * A06 / R9-2: subscribe before resetting, then join an in-flight round's end ("replica busy" retries). A reset whose
 * own download fails rejects with that error in the binding (F17), so the caller reports it and the next open retries.
 */
export async function resetSpaceReplicaWhenIdle(driver: TursoWorkerDatabaseDriver, reset: () => Promise<unknown>) {
  let roundEnded = Promise.resolve()
  let endRound = () => {}
  const beginAttempt = () => { roundEnded = new Promise<void>(resolve => { endRound = resolve }) }
  const release = await driver.subscribeReplica(state => { if (state.status !== 'exchanging') endRound() })
  try {
    for (let attempt = 0; ; attempt++) {
      beginAttempt()
      try { await reset(); return }
      catch (error) {
        if (attempt >= 5 || !(error instanceof Error && error.message.includes('replica busy'))) throw error
        await roundEnded
      }
    }
  } finally { release() }
}
